/* eslint-disable no-undef */

// Polyfills
import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import CacheBuster from 'react-cache-buster';
// NOTA: CacheBuster permite forzar el recargo del frontend si hay una nueva versión del bundle en TEST o PRODUCTION.

import App from './App';

// Crear una versión "dummy" porque CacheBuster solo usa eso para comparar contra meta.json.
const currentVersion = `${Date.now()}`;
const isProduction = process.env.NODE_ENV === 'production';

ReactDOM.render(
  <CacheBuster
    currentVersion={currentVersion} // Versión "dummy" siempre será diferente, forzará comparación
    isEnabled={isProduction} // Solo aplica en entornos de TEST y PRODUCTION
    metaFileDirectory="/talentry" // Ruta donde está /meta.json, en este caso es /public/meta.json
    reloadOnUpdate={true} // Recarga automáticamente al detectar nueva versión
  >
    <App />
  </CacheBuster>,
  document.getElementById('root')
);
serviceWorker.unregister();
